module.exports = __webpack_public_path__ + "img/create-a-product-consumer.80e120ab.png";